import { render, staticRenderFns } from "./followUs.vue?vue&type=template&id=594c8ea4&scoped=true"
import script from "./followUs.vue?vue&type=script&lang=js"
export * from "./followUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c8ea4",
  null
  
)

export default component.exports